import React, { Fragment } from 'react';
import { useTranslation } from '@yme/services/i18n';
import { buildKey } from '@yme/utils/common';
import { Cell } from './Cell';
import { TableWrapperStyled, TableBodyStyled, TableRowStyled, TableHeadStyled } from './styled';
export function BaseTable(props) {
    const { rows, columns, cellWidth, isRightToLeft = false, children, extraBottomRow, className, tHeadColumns, dataTestId = 'BaseTable', hasEmptyCells, } = props;
    const { t } = useTranslation();
    if (!rows && !columns && !children) {
        return null;
    }
    return (React.createElement(TableWrapperStyled, { "aria-label": t('common_table_accessibility'), className: className, "data-testid": dataTestId }, children || (React.createElement(React.Fragment, null,
        tHeadColumns && tHeadColumns?.length > 0 && (React.createElement(TableHeadStyled, null,
            React.createElement(TableRowStyled, null, tHeadColumns.map((column, index) => {
                const keyTHeadItemCell = buildKey(Object.keys(column)[0], `thead_cell_${index}`);
                return (React.createElement(Cell, { key: keyTHeadItemCell, row: column, isRightToLeft: isRightToLeft, hasEmptyCells: hasEmptyCells, ...column }));
            })))),
        React.createElement(TableBodyStyled, null, rows && rows?.length > 0 && (React.createElement(React.Fragment, null, rows.map((row, index) => {
            const keyItemRow = buildKey(Object.keys(row)[0], `tbody_row_${index}`);
            const countOfColumns = columns?.length;
            return (React.createElement(Fragment, { key: keyItemRow },
                React.createElement(TableRowStyled, null, columns?.length &&
                    columns.map((column, inx) => {
                        const keyItemCell = buildKey(Object.keys(column)[0], `tbody_row_${index}_cell_${inx}`);
                        return (React.createElement(Cell, { key: keyItemCell, row: row, cellWidth: cellWidth, isRightToLeft: isRightToLeft, hasEmptyCells: hasEmptyCells, ...column }));
                    })),
                extraBottomRow && extraBottomRow?.length > 0 && countOfColumns && (React.createElement(TableRowStyled, null,
                    React.createElement(Cell, { row: row, colSpan: countOfColumns, cellWidth: cellWidth, isRightToLeft: isRightToLeft, hasEmptyCells: hasEmptyCells, ...extraBottomRow[0] })))));
        }))))))));
}
BaseTable.displayName = 'BaseTable_Component';
